import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';
import type { PriceTagProductData } from '@Types/PriceTag';

interface Params {
  sellPointId: string;
}

async function getSellPointChangedPrice(params: Params): Promise<PriceTagProductData[]> {
  const url = `/backend/site/get-sell-point-changed-price?sellPointId=${params.sellPointId}`;
  const res = await Api.queryProxi<ApiResponse<PriceTagProductData[]>>(url);

  if (!res.ok) throw new BackendError(url, res);
  return res.data;
}

export default getSellPointChangedPrice;
